/**
 * KPIs whose goal (target) may be edited per calendar year. Keep aligned with
 * `targetEditableKpiIds` / `EXECUTIVE_PULSE_KPI_IDS` in oracle-backend
 * `executive-pulse-kpi-catalog.js`.
 */
const EXECUTIVE_PULSE_TARGET_EDITABLE_KPI_IDS = Object.freeze([
    'ep-financial-db-consults-1499',
    'ep-financial-unitas-consults-3701',
    'ep-financial-hsra-500',
    'ep-customer-qbr-process',
    'ep-customer-delivered-practices-80pct',
    'ep-customer-digital-100pct',
    'ep-customer-churn-reduction-10pct',
    'ep-process-copilot-offices-400',
    'ep-process-gross-profit-600k',
    'ep-process-people-vision-2028',
    'ep-process-12-month-plan',
    'ep-growth-1a-q1-2026',
    'ep-growth-1b-q2-2026'
]);

export default EXECUTIVE_PULSE_TARGET_EDITABLE_KPI_IDS;
